import PropTypes from "prop-types";
import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";
import Typography from "@shared/v2/Typography";

const DeleteLenderModal = ({ show, onClose }) => (
  <Modal
    show={show}
    onHide={onClose}
    dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
    contentClassName="tw-max-w-[440px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
  >
    <Modal.Header title="Delete Lender" closeButton />
    <Modal.Body className="tw-flex tw-flex-col tw-gap-[24px]">
      <Typography variant="body-m">
        This lender will no longer be featured on your listing pages. Are you sure you want to delete the
        lender?
      </Typography>
    </Modal.Body>
    <Modal.Footer className="tw-flex tw-justify-between tw-gap-[16px]">
      <Button size="medium" schema="tertiary" onClick={onClose}>
        Cancel
      </Button>
      <Button size="medium" schema="warning" onClick={onClose}>
        Yes, Delete
      </Button>
    </Modal.Footer>
  </Modal>
);

DeleteLenderModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DeleteLenderModal;
